import '@sonnen/web-ui/dist/web-ui.css';
import './App.css';
import { ModalPortal } from '@sonnen/web-ui';
import { addTranslations } from '@sonnen/web-utils';
import { ApolloProviderWrapper, ApolloProviderWrapperConfig } from '@sonnen/web-utils/components';
import { useAuth } from '@sonnen/web-utils/hooks';
import { useEffect, useMemo } from 'react';
import { useAppContext } from './AppContext/AppContext';
import { AppRoutes } from './AppRoutes/AppRoutes';
import { ROOT_MODAL_ID } from './constants';
import * as de from './locales/de.json';
import * as en from './locales/en-GB.json';
import { OfferContextProvider } from './OfferContext/OfferContext';

addTranslations({ de, 'en-GB': en });

const App = () => {
  const removeUser = () => localStorage.removeItem('web-utils:user');
  const { user: authenticatedUser } = useAuth();
  const { currentModal } = useAppContext();

  const config: ApolloProviderWrapperConfig = useMemo(
    () => ({ apiUri: process.env.VITE_GRAPHQL_API }),
    [authenticatedUser],
  );

  useEffect(() => {
    window.addEventListener('webview-unload', removeUser);
    return () => window.removeEventListener('webview-unload', removeUser);
  }, [authenticatedUser]);

  return (
    <ApolloProviderWrapper config={config}>
      <OfferContextProvider>
        <AppRoutes />
      </OfferContextProvider>
      <div id={ROOT_MODAL_ID} />
      <ModalPortal rootId={ROOT_MODAL_ID} open={Boolean(currentModal)}>
        {currentModal}
      </ModalPortal>
    </ApolloProviderWrapper>
  );
};

export default App;
